import type { TableColumnCtx } from 'element-plus';

export type TableColumn<
  TRow extends Record<string, unknown> = Record<string, unknown>,
  TRequired extends keyof TableColumnCtx<TRow> = 'prop' | 'label',
> = Partial<TableColumnCtx<TRow>> & Required<Pick<TableColumnCtx<TRow>, TRequired>>;

export enum SortParams {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
}

export enum SortingMapping {
  ascending = 'a',
  descending = 'd',
}

export enum TagComponentTypes {
  PRIMARY = 'primary',
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  DANGER = 'danger',
}

export enum NotificationStatusType {
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
  ERROR = 'error',
  PRIMARY = 'primary',
}
